<template>
  <div class="d-flex align-items-center document-button">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'DocumentButtonsGroup'
}
</script>

<style scoped lang="scss">
.document-button {
  background-color: #deebff;
  border-radius: 5px;
  padding: 6px 16px;

  & > *:hover {
    opacity: 0.8;
  }

  & > *:not(:first-child) {
    margin-left: 11px;
  }
}
</style>
